export default {"src":"/_next/static/media/arrow-right.18dfb6e1.svg","height":288,"width":288};